"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ServiceHelper = /** @class */ (function () {
    function ServiceHelper() {
    }
    ServiceHelper.prototype.checkUrlPrefix = function (url) {
        return url.endsWith("/nxt") ? url : url += "/nxt";
    };
    ServiceHelper.prototype.setPromiseReturn = function (responseData) {
        return responseData.errorCode ? Promise.reject(responseData)
            : Promise.resolve(responseData);
    };
    return ServiceHelper;
}());
exports.default = ServiceHelper;
